import React from "react";
import type { FC } from "react";
import logo from "../../../assests/images/logo.webp";
import { Link } from "react-router-dom";

interface LogoProps {
  otherStyle: string | undefined;
  children?: JSX.Element;
  logoUrl?: string
}

const Logo: FC<LogoProps> = ({ otherStyle, logoUrl = "/service"}) => {
  return (
    <Link to={logoUrl}>
      <div className={otherStyle}>
        <img className="w-full h-full" src={logo} alt="None" />
      </div>
    </Link>
  );
};

export default Logo;
